import clearDay from '../assets/clear-day.svg';
import clearNight from '../assets/clear-night.svg';
import cloudyDay from '../assets/cloudy-day.svg';
import cloudyNight from '../assets/cloudy-night.svg';
import fog from '../assets/fog.svg';
import rain from '../assets/rain.svg';
import snow from '../assets/snow.svg';
import thunder from '../assets/thunder.svg';
import wind from '../assets/wind.svg';
import flake from '../assets/flake.svg';
import humid from '../assets/humid.svg';
import air from '../assets/air.svg';

export default {
  clearDay,
  clearNight,
  cloudyDay,
  cloudyNight,
  fog,
  rain,
  snow,
  thunder,
  wind,
  air,
  flake,
  humid
};